"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.storePreloadedState = exports.storePreloadedStateCreator = exports.store = void 0;
const tslib_1 = require("tslib");
const toolkitRaw = tslib_1.__importStar(require("@reduxjs/toolkit"));
const redux_1 = require("./redux");
var redux_2 = require("./redux");
Object.defineProperty(exports, "store", { enumerable: true, get: function () { return tslib_1.__importDefault(redux_2).default; } });
function storePreloadedStateCreator(preloadedState) {
    return toolkitRaw.configureStore({
        reducer: redux_1.rootReducers,
        preloadedState: preloadedState,
    });
}
exports.storePreloadedStateCreator = storePreloadedStateCreator;
class storePreloadedState {
    constructor() {
        this.instanceStore = null;
        this.initInstance();
    }
    static setPreloaded(preloadState) {
        this.preloadState = preloadState;
    }
    static getInstance() {
        if (!storePreloadedState.instance) {
            return (storePreloadedState.instance = new storePreloadedState());
        }
        return storePreloadedState.instance;
    }
    static getInstanceStore() {
        return this.getInstance().instanceStore;
    }
    initInstance() {
        const instance = toolkitRaw.configureStore({
            reducer: redux_1.rootReducers,
            preloadedState: storePreloadedState.preloadState,
        });
        this.instanceStore = instance;
        return instance;
    }
}
exports.storePreloadedState = storePreloadedState;
storePreloadedState.preloadState = {};
//# sourceMappingURL=index.js.map